import React, { useEffect, useState } from 'react';
import request from '../../../../utils/request';
import ValidateLoader from '../../../../UI/validateLoader';
import {
  categoryFormIds as formIds,
  categoryFormNameMap,
  categoryFormKeys
} from '../../../../utils/constant';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { useLocaleContext } from '../../../../context/LocaleContext';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../../../contentful';
import {
  formCategoryContainerStyle,
  formCategoryStyle,
  selected,
  unselected,
  unselectedcolor,
  colorselected
} from '../../../../form/style';
import Switch from 'react-switch';

const FormFreeze = () => {
  const [isOrderFreezed, setOrderFreezed] = useState(0);
  const [isReferralFreezed, setReferralFreezed] = useState(0);
  const [isWirelessFreezed, setWirelessFreezed] = useState(0);
  const [isBRPFreezed, setBRPFreezed] = useState(0);
  const [isVULFormFreezed, setVULFormFreezed] = useState(0);
  const [isFMFreezed, setFMFreezed] = useState(0);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState(null);
  const [orderButtonTitle, setOrderButtonTitle] = useState('');
  const locale = useLocaleContext();
  const config = { ...contentfulFormConfig, locale };

  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      FORM: {
        MESSAGE: { LOADING }
      }
    }
  } = localizedStrings;

  const getFormFreezeDetails = async () => {
    setLoading(true);
    try {
      const [
        {
          data: { value: orderVal }
        },
        {
          data: { value: referralVal }
        },
        {
          data: { value: wirelessVal }
        },
        {
          data: { value: brpVal }
        },
        {
          data: { value: vulcanVal }
        },
        {
          data: { value: fmVal }
        }
      ] = [
        await request.get(`/options/${formIds.ORDER}`),
        await request.get(`/options/${formIds.REFERRAL}`),
        await request.get(`/options/${formIds.WIRELESS}`),
        await request.get(`/options/${formIds.BRP}`),
        await request.get(`/options/${formIds.VULCAN}`),
        await request.get(`/options/${formIds.FM}`)
      ];
      const [
        orderFormFreeze,
        referralFormFreeze,
        wirelessFormFreeze,
        brpFormFreeze,
        vulcanFormFreeze
      ] = [
        JSON.parse(orderVal),
        JSON.parse(referralVal),
        JSON.parse(wirelessVal),
        JSON.parse(brpVal),
        JSON.parse(vulcanVal)
      ];
      setOrderFreezed(orderFormFreeze);
      setReferralFreezed(referralFormFreeze);
      setWirelessFreezed(wirelessFormFreeze);
      setBRPFreezed(brpFormFreeze);
      setVULFormFreezed(vulcanFormFreeze);
      setFMFreezed(fmFormFreeze);
    } finally {
      setLoading(false);
    }
  };

  const setFormFreeze = async (id, val) => {
    const newValue = val === 0 ? 1 : 0;
    const { status } = await request.post(`/options/${id}`, {
      value: newValue
    });
    if (status === 200) {
      if (id === formIds.ORDER) {
        setOrderFreezed(newValue);
      } else if (id === formIds.REFERRAL) {
        setReferralFreezed(newValue);
      } else if (id === formIds.WIRELESS) {
        setWirelessFreezed(newValue);
      } else if (id === formIds.BRP) {
        setBRPFreezed(newValue);
      } else if (id === formIds.VULCAN) {
        setVULFormFreezed(newValue);
      } else if (id === formIds.FM) {
        setFMFreezed(newValue);
      }
    }
  };

  useEffect(() => {
    getFormFreezeDetails();
  }, []);

  useEffect(() => {
    getContentfulData(config).then(res => {
      const { formCategories } = getData(res);
      const contentfulCategories = formCategories.map(
        ({ fields: { title, name, image, forms } }) => ({
          title,
          name,
          image,
          forms
        })
      );
      const formCategoriesObj = {};
      contentfulCategories.forEach(cat => {
        if (cat.name === 'wireline and secure business') {
          setOrderButtonTitle(cat.forms[1].fields.title);
        }
        return (formCategoriesObj[categoryFormNameMap[cat.name]] = cat);
      });
      setCategories(formCategoriesObj);
    });
  }, [locale]);
  return (
    <>
      <div className="layout-container">
        {loading || !categories ? (
          <ValidateLoader message={LOADING} />
        ) : (
          <div className="checking form-freeze-section-grid">
            <div style={formCategoryStyle(true)}>
              <div style={isOrderFreezed ? unselected : selected}>
                <h2 style={isOrderFreezed ? unselectedcolor : colorselected}>
                  {categories[categoryFormKeys.ORDER].title}
                </h2>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() =>
                        setFormFreeze(formIds.ORDER, isOrderFreezed)
                      }
                      checked={(!formIds.ORDER, !isOrderFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isReferralFreezed ? unselected : selected}>
                <h2 style={isReferralFreezed ? unselectedcolor : colorselected}>
                  {categories[categoryFormKeys.REFERRAL].title}
                </h2>
                <br />
                <br />
                <>
                  <span>
                    <div style={{ marginTop: '20px' }}>
                      <Switch
                        onColor="#4B286D"
                        onChange={() =>
                          setFormFreeze(formIds.REFERRAL, isReferralFreezed)
                        }
                        checked={(!formIds.REFERRAL, !isReferralFreezed)}
                      />
                    </div>
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isWirelessFreezed ? unselected : selected}>
                <h2 style={isWirelessFreezed ? unselectedcolor : colorselected}>
                  {categories[categoryFormKeys.WIRELESS].title}
                </h2>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() =>
                        setFormFreeze(formIds.WIRELESS, isWirelessFreezed)
                      }
                      checked={(!formIds.WIRELESS, !isWirelessFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isBRPFreezed ? unselected : selected}>
                <h2 style={isBRPFreezed ? unselectedcolor : colorselected}>
                  {categories[categoryFormKeys.BRP].title}
                </h2>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() => setFormFreeze(formIds.BRP, isBRPFreezed)}
                      checked={(!formIds.BRP, !isBRPFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isVULFormFreezed ? unselected : selected}>
                <h2 style={isVULFormFreezed ? unselectedcolor : colorselected}>
                  {categories[categoryFormKeys.VULCAN].title}
                </h2>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() =>
                        setFormFreeze(formIds.VULCAN, isVULFormFreezed)
                      }
                      checked={(!formIds.VULCAN, !isVULFormFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isFMFreezed ? unselected : selected}>
                <h2 style={isFMFreezed ? unselectedcolor : colorselected}>
                  {categories[categoryFormKeys.FM].title}
                </h2>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() => setFormFreeze(formIds.FM, isFMFreezed)}
                      checked={(!formIds.FM, !isFMFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FormFreeze;
